import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { CPQScreenOption } from '../../../models/CPQUI';


@Component({
  selector: 'app-textbox',
  templateUrl: './textbox.component.html',
  styleUrls: ['./textbox.component.css']
})
export class TextboxComponent implements OnInit {
  @Output() OnBlurChangeEmitter: EventEmitter<any> = new EventEmitter();
  @Output() CheckInvalidEmitter: EventEmitter<any> = new EventEmitter();
  @Input() type: string;
  CurrentScreenOption: CPQScreenOption;
  MinValue: number;
  MaxValue: number;  
  DisplayValue: string;
  constructor() { }

  ngOnInit(): void {
  }

  SetControl(control: CPQScreenOption) {
    this.CurrentScreenOption = control;

    this.DisplayValue = this.CurrentScreenOption.Value;

    if (this.type == "number") {
      this.DisplayValue = this.DisplayValue.replace(",", "");
    }

    if (this.CurrentScreenOption.Ranges && this.CurrentScreenOption.Ranges.length > 0) {
      this.MinValue = this.CurrentScreenOption.Ranges[0].Min;
      this.MaxValue = this.CurrentScreenOption.Ranges[0].Max;
    }
    else {
      this.MinValue = -1000000;
      this.MaxValue = 1000000;
    }
  }


  textOnBlur(event: any, autoContinueMode: number) {
    debugger;
    if (this.type == "number") {
      if (this.CurrentScreenOption.Value.length > 0 && this.CurrentScreenOption.Ranges.length > 0) {
        var test = parseFloat(this.CurrentScreenOption.Value.replace(/[^\d.]/, ""));
        if (test < this.CurrentScreenOption.Ranges[0].Min || test > this.CurrentScreenOption.Ranges[0].Max) {
          //show validation
          this.CurrentScreenOption.IsValid = false;
          this.CheckInvalidEmitter.emit("invalid");
        }
        else {
          this.OnBlurChangeEmitter.emit(this.CurrentScreenOption);
        }
      } else {
        this.OnBlurChangeEmitter.emit(this.CurrentScreenOption);
      }
    }
    else {
      this.OnBlurChangeEmitter.emit(this.CurrentScreenOption);
    }
    
  }

  checkRanges() {
    if (this.type == "number") {
      if (this.CurrentScreenOption.Value.length > 0 && this.CurrentScreenOption.Ranges.length > 0) {
        var test = parseFloat(this.CurrentScreenOption.Value.replace(/[^\d.]/, ""));
        if (test < this.CurrentScreenOption.Ranges[0].Min || test > this.CurrentScreenOption.Ranges[0].Max) {
          //show validation
          this.CurrentScreenOption.IsValid = false;
          this.CheckInvalidEmitter.emit("invalid");
        }
      }
    }
  }
}
